module.exports = __webpack_public_path__ + "img/gallery-hero.5b235c29.jpg";